<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>No Conformidad (EI044) - Listado</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="4" md="2">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por N° N.C." dense v-model="filtrocodgral">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Fecha" dense v-model="filtrofecha">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Originante" dense v-model="filtrooriginante">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="4" md="4">
                            <v-select dense v-model="filtroproveedor" :items="proveedor" label="Filtro por Proveedor"
                                item-text="nombre" item-value="proveedor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Referencia" dense v-model="filtroreferencia">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Responsable" dense v-model="filtroresponsable">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headersP" :items="listadoP" locale="es-ar" class="elevation-1"
                :items-per-page="20" :footer-props="{
                    itemsPerPageText: 'NC por página',
                }" :loading="loadtable" loading-text="Cargando... Espere por favor"
                no-data-text="No hay datos disponibles">
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verNC(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver NC</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <VerNC :visible="showNC" :codgral="editedItem.codgral" @close="showNC = false"></VerNC>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth";
import VerNC from "../EI044/Informe.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    components: { VerNC },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "T",
        // filtroestado: [
        // { detalle: "Todos", valor: "Todos" },
        // ],
        filtrocodgral: "",
        filtroproveedor: [],
        filtrofecha: "",
        filtrooriginante: "",
        filtroresponsable: "",
        filtroreferencia: "",
        listadoP: [],
        showNC: false,
        loadtable: false,
        estado: [
            { detalle: "Todos", valor: "T" },
            { detalle: "Pendiente Análisis", valor: "PA" },
            { detalle: "Pendiente Seguimiento", valor: "PS" },
            { detalle: "Pendiente Eficacia", valor: "PE" },
            { detalle: "Cerrado", valor: "C" },
        ],
        proveedor: [],
        headersP: [
            {
                text: "Código",
                align: "start",
                sortable: false,
                value: "codgral",
            },
            { text: "Referencia", value: "referencia", sortable: false },
            { text: "Originante", value: "originante", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Responsables", value: "responsable", sortable: false },
            { text: "Participante", value: "participante", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarProve();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarProve() {
            let self = this;
            axios
                .get("/Obras/GetProve?")
                .then((response) => {
                    self.proveedor = response.data;
                })
                .catch((error) => {
                    self.proveedor = [];
                    console.log(error);
                });
        },

        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            const codgral = this.filtrocodgral;
            const fecha = this.filtrofecha;
            const referencia = this.filtroreferencia;
            const proveedor = this.filtroproveedor;
            const estado = this.filtroestado;
            const responsable = this.filtroresponsable;
            const originante = this.filtrooriginante;

            let self = this;

            axios
                .get("/App/ListadoEI044?", {
                    params: {
                        codgral: codgral,
                        fecha: fecha,
                        originante: originante,
                        referencia: referencia,
                        proveedor: proveedor,
                        estado: estado,
                        responsable: responsable,

                    },
                })
                .then((response) => {
                    self.listadoP = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    console.log(error);
                });
        },
        verNC(item) {
            this.editedIndex = this.listadoP.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showNC = true;
        },
        vaciarModels() {
            this.listadoP = [];
        },
    },
};
</script>